<!--
  File name: ExportPDBNF.vue
  Program Description:
    - This component holds the details of the Personal Data Breach Notification
    Form export.
    - When accessed, it renders the whole export PDF of the Personal Data Breach
    Notification, combining the headers, type, and the PDBNF details into one
    layout

  Includes:
    * NPC Report Header
    * Notification Type
    * PDBNF Details

-->
<template>
  <span>
    <div
      v-if="data"
      class="text-center"
    >
      <NPCReportHeader :data="data" />
      <div
        style="margin: 20px"
      >
        <NotificationType :data="data" />
        <PDBNFDetails :data="data" />
      </div>
    </div>
    <v-col
      v-else
      align="center"
    >
      Something went wrong with the Personal Data Breach Notification Form export.
    </v-col>
  </span>
</template>

<script>
import NPCReportHeader from './NPCReportHeader.vue'
import NotificationType from './NotificationType.vue'
import PDBNFDetails from './PDBNFDetails.vue'

export default {
  components: {
    NPCReportHeader,
    NotificationType,
    PDBNFDetails
  },
  props: {
    data: {
      type: Object,
      default: null
    }
  }
}
</script>
